import { InvoiceItemModel } from "types/generated/models";
import { useInitializeStripe } from "../../Shared/Stripe";
import InvoiceStripePaymentShared from "../../Shared/StripePayment/InvoiceStripePaymentShared";
import { Button, Box, Card } from "@mui/material";
import { useState } from "react";
import { useClientPortalConfigContext } from "../../../context/ClientPortalConfig.ctx";
import StripeProvider from "../../Shared/Stripe/StripeProvider";
import LoadingOverlay from "../../Shared/LoadingOverlay";
import InvoicePaymentSuccessful from "../InvoicePaymentSuccessful";

const FORM_ID = "invoice_pay_stripe_payment_form";

interface InvoiceStripePaymentProps {
    invoice: InvoiceItemModel;
}

export default function InvoiceStripePayment({ invoice }: Readonly<InvoiceStripePaymentProps>) {
    const [paymentCompleted, setPaymentCompleted] = useState(false);
    const { clientPortalConfig } = useClientPortalConfigContext();
    const { stripe, loading: stripeLoading } = useInitializeStripe({
        stripeKey: clientPortalConfig.stripeKey,
        practitionerStripeAccountId: invoice.practitioner.stripeAccount,
    });
    const handleSuccessfulPayment = () => {
        setPaymentCompleted(true);
    };
    return (
        <Box
            data-test-id="invoice_pay_stripe_payment"
            sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
            }}
        >
            {paymentCompleted ? (
                <InvoicePaymentSuccessful invoiceNumber={invoice.invoiceNumber} />
            ) : (
                <>
                    {stripeLoading ? (
                        <LoadingOverlay />
                    ) : (
                        <StripeProvider stripe={stripe}>
                            <Card variant="outlined" sx={{ padding: "20px" }}>
                                <InvoiceStripePaymentShared
                                    amount={invoice?.amountOwingDecimal}
                                    fee={invoice.fee}
                                    invoiceIds={[invoice.id]}
                                    practitionerId={invoice.practitioner.practitionerId}
                                    totalAmount={invoice.amountOwingDecimal + invoice.fee}
                                    {...(!clientPortalConfig.userLoggedIn && { clientId: invoice.clientId })}
                                    formId={FORM_ID}
                                    onSuccessfulPayment={() => void handleSuccessfulPayment()}
                                />

                                <Button
                                    variant="contained"
                                    type="submit"
                                    size="large"
                                    form={FORM_ID}
                                    fullWidth
                                    data-test-id="button_pay_invoice"
                                >
                                    Pay Now
                                </Button>
                            </Card>
                        </StripeProvider>
                    )}
                </>
            )}
        </Box>
    );
}
